'use client';

import { Link } from '@mokoboko/components';

export const StudioContactBox = ({
  heading,
  message,
  supportEmail,
  phoneHref,
}: {
  heading?: string;
  message: string;
  supportEmail?: string | null;
  phoneHref?: string | null;
}) => (
  <div className="flex w-full flex-col gap-2">
    {heading && (
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">
        {heading}
      </p>
    )}
    <div className="rounded-[10px] bg-gray-100 px-4 py-3 text-sm leading-5 text-gray-700">
      <p>
        {message}{' '}
        {supportEmail && (
          <Link
            href={`mailto:${supportEmail}`}
            size="sm"
            className="m-0 inline p-0"
          >
            Email us
          </Link>
        )}
        {supportEmail && phoneHref && (
          <span className="mx-1.5 text-gray-500">·</span>
        )}
        {phoneHref && (
          <Link href={phoneHref} size="sm" className="m-0 inline p-0">
            Call us
          </Link>
        )}
      </p>
    </div>
  </div>
);
